// Les Filigrines — animations landing « Modéré » (handoff design VALIDÉ 2026-07,
// logique de référence copiée verbatim — ne pas modifier : seuil, délais, durées validés).
//
// Conserve le contrat historique : html.lf-js (posé inline dans theme.liquid), toggle
// .is-visible sur les .lf-reveal à l'entrée dans le viewport, re-scan à
// shopify:section:load (l'éditeur re-rend les sections à chaque réglage), et mode
// éditeur = révéler SANS animation (une section re-rendue hors viewport ne déclencherait
// jamais l'observer et resterait invisible).
//
// S'y ajoutent : le découpage mot à mot de la citation vedette (lf-testimonials), le
// dessin trait par trait des icônes des piliers (lf-quality, data-lf-draw), et le
// nettoyage du fill-mode à animationend (.is-done) — sans lui, animation-fill-mode:both
// fige le transform et casse les hovers existants (translateY des cartes).
(function () {
  var inEditor = !!(window.Shopify && window.Shopify.designMode);
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var animates = 'IntersectionObserver' in window && !inEditor && !reduced;
  var EASE = 'cubic-bezier(.22, 1, .36, 1)';

  // --- Citation vedette : découper le blockquote en mots (une seule fois).
  // Cible : .lf-quote-star blockquote (section lf-testimonials).
  function splitQuoteWords(root) {
    (root || document).querySelectorAll('.lf-quote-star blockquote').forEach(function (bq) {
      if (bq.dataset.lfSplit) return;
      bq.dataset.lfSplit = '1';
      var words = bq.textContent.trim().split(/\s+/);
      bq.textContent = '';
      words.forEach(function (w, i) {
        var s = document.createElement('span');
        s.setAttribute('data-qw', '');
        s.textContent = w;
        // délai validé : i × 40ms
        s.style.animationDelay = (i * 40) + 'ms';
        bq.appendChild(s);
      });
    });
  }

  // --- Icônes « Nos valeurs » : dessin trait par trait au reveal.
  // data-lf-draw est posé sur la carte pilier (elle porte aussi .lf-reveal--pop).
  function prepDraw(box) {
    box.querySelectorAll('path, circle, line').forEach(function (p) {
      try {
        var L = p.getTotalLength();
        p.style.transition = 'none';
        p.style.strokeDasharray = L;
        p.style.strokeDashoffset = L;
      } catch (e) { /* élément non géométrique : ignorer */ }
    });
  }
  function revealDraw(box, baseDelayMs) {
    // durée de dessin par élément : data-drawdur (ms), défaut 800 (le fil « Nos valeurs » = 2600).
    var dur = parseInt(box.getAttribute('data-drawdur'), 10) || 800;
    box.querySelectorAll('path, circle, line').forEach(function (p, i) {
      // délais validés : base + 250ms + i × 130ms
      p.style.transition = 'stroke-dashoffset ' + dur + 'ms ' + EASE + ' ' + (baseDelayMs + 250 + i * 130) + 'ms';
      requestAnimationFrame(function () { p.style.strokeDashoffset = '0'; });
    });
  }

  var io = animates
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting || e.intersectionRatio < 0.1) return;
          var el = e.target;
          if (el.classList.contains('lf-reveal')) el.classList.add('is-visible');
          if (el.hasAttribute('data-lf-draw')) {
            // le stagger est dans --lf-rd (ms)
            var rd = parseInt(getComputedStyle(el).getPropertyValue('--lf-rd')) || 0;
            revealDraw(el, rd);
          }
          io.unobserve(el); // reveal UNE seule fois (validé)
        });
      }, { threshold: [0, 0.12] })
    : null;

  function reveal(root) {
    splitQuoteWords(root);
    // On observe les .lf-reveal ET les [data-lf-draw] autonomes : un dessin (le fil « Nos
    // valeurs », le « 30 % » cerclé) peut vivre hors d'une carte .lf-reveal.
    (root || document).querySelectorAll('.lf-reveal, [data-lf-draw]').forEach(function (el) {
      if (io) {
        io.observe(el);
      } else if (el.classList.contains('lf-reveal')) {
        el.classList.add('is-visible', 'is-done'); // pas d'animation (éditeur / reduced / vieux navigateur)
      }
    });
    if (!animates) {
      (root || document).querySelectorAll('[data-lf-draw] path, [data-lf-draw] circle, [data-lf-draw] line')
        .forEach(function (p) { p.style.strokeDasharray = ''; p.style.strokeDashoffset = ''; });
    } else {
      (root || document).querySelectorAll('[data-lf-draw]').forEach(prepDraw);
    }
  }

  // Nettoyage du fill-mode : à la fin de son animation, l'élément passe en
  // .is-done (opacity:1; animation:none) → les hovers transform refonctionnent.
  // OBLIGATOIRE : sans ça, animation-fill-mode:both fige le transform.
  document.addEventListener('animationend', function (e) {
    var el = e.target;
    if (el.classList && el.classList.contains('lf-reveal')) el.classList.add('is-done');
  });

  reveal(document);
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
